// Available floor types from backend
export const FLOOR_TYPES = {
  'UNKNOWN': {label: 'Unbekannt', value: 'UNKNOWN'},
  'BASEMENT_FLOOR': {label: 'Keller', value: 'BASEMENT_FLOOR'},
  'GROUND_FLOOR': {label: 'Erdgeschoss/Souterrain', value: 'GROUND_FLOOR'},
  'HIGH_NORMAL_FLOOR': {label: 'Hochparterre', value: 'HIGH_NORMAL_FLOOR'},
  'NORMAL_FLOOR': {label: 'Normale Etage', value: 'NORMAL_FLOOR'},
  'MEZZANINE_FLOOR': {label: 'Zwischengeschoss', value: 'MEZZANINE_FLOOR'},
  'MAISONETTE': {label: 'Maisonette', value: 'MAISONETTE'},
  'ATTIC_FLOOR': {label: 'Dachgeschoss', value: 'ATTIC_FLOOR'}
};
